<template>
  <div class="container">
    <common-card title="Search Cube Order">
      <div class="pick-order">
        <div class="order-no-input">
          <el-input placeholder="Input order no from Stupid CubeWMS" clearable v-model="orderNoInput" size="medium">
            <template slot="prepend">Order No</template>
          </el-input>
          <div>
            <!-- <el-button size="small" type="primary" class="add-button">
              <div class="inner">
                <svg-icon icon-class="plus" class="svg-white-color" style="font-size: 16px;" />
                <span>Create Pallets</span>
              </div>
            </el-button> -->
            <el-button size="small" type="primary" class="add-button">
              <div class="inner" @click="() => searchOrder(orderNoInput)">
                <svg-icon icon-class="info" class="svg-white-color" style="font-size: 16px;" />
                <span>Refresh</span>
              </div>
            </el-button>
          </div>
        </div>
        <div class="order-preview" v-loading="loadingOrderInfo">
          <div v-if="orderInfo" class="order-detail">
            <div class='address-info'>
              <div class="purchase-no">
                <div class="">Purchase Order No: </div>
                <div class="bold-oswald">{{ orderInfo.purchaseNo }}</div>
              </div>
              <div class="purchase-no">
                <div class="">Customer: </div>
                <div class="bold-oswald">{{ orderInfo.riiCustomer }}</div>
              </div>
              <div class="purchase-no">
                <div class="">Platform: </div>
                <div class="bold-oswald">{{ orderInfo?.platform ?? 'Unknown' }}</div>
              </div>
              <div class="address-item">
                <span class="light-oswald">{{ orderInfo.address.street }}</span>
                <span class="light-oswald">{{ orderInfo.address.block }}</span>
                <span class="light-oswald">{{ orderInfo.address.detail }}</span>
                <span class="light-oswald">{{ orderInfo.address.city }}</span>
                <span class="light-oswald">{{ orderInfo.address.zip }}</span>
                <span class="light-oswald">{{ orderInfo.address.state }}</span>
              </div>
            </div>
            <div class="product-list">
              <div v-for="(item, index) in orderInfo.stock" :key="index" class="order-product-item">
                <div class="left">
                  <div class="sku">
                    <span>{{ item.productNo }}</span>
                  </div>
                  <div class="barcode" style="font-weight: bold">
                    <span>barcode {{ item.barcode }}</span>
                  </div>
                  <div class="barcode">
                    <span>weight: {{ item.weight }}</span>
                  </div>
                  <div class="barcode">
                    <span>volume: {{ item.volume }}</span>
                  </div>
                </div>
                <div class="right">
                  <span style="line-height: 1.0;">{{ item.leftQuantity }} / {{ item.quantityAvailable }}</span>
                  <el-tag v-if="item.serialNoRequired" size="mini" type="warning">S/N Required</el-tag>
                  <el-button class="add-stock-but" :disabled="item.leftQuantity === 0" size="mini"
                    @click="() => addPalletStock(item, index)">Add Stock</el-button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="nothing-display">
            <div>No information to display</div>
          </div>
        </div>
      </div>
    </common-card>
    <div class="pallet-container">
      <div class="pallet-left">
        <basic-form class="input-form" ref="palletForm" title="Pallets Group Info" :show-clear="true"
          :mode="FormModes.SINGLE" :form-params="palletForm" :change-date="val => (date = val)"
          :value-change-cb="(key, val) => formValueChange(palletForm, key, val)">
          <template v-slot:bottom-actions>
            <div class="f-c">
              <div class="pallets-stock-list">
                <span class="list-title">Stock List</span>
                <div v-for="(stock, index) in palletStock" :key="index" class="pallet-stock-item f-r-c-sb">
                  <div class="left">
                    <div class="stock-info-item first light-oswald">
                      <span>{{ stock.orderNo }}</span>
                      <span class="product-no" :title="stock.productNo">No. {{ stock.productNo }}</span>
                    </div>
                    <div class="stock-info-item barcode product-name">
                      <span class="product-name" :title="stock.productName">{{ stock.productName }}</span>
                    </div>
                    <div class="stock-info-item barcode">
                      <span>{{ stock.barcode }}</span>
                    </div>
                  </div>
                  <div class="right f-c">
                    <div class="f-r-c-sb">
                      <div class="f-c" style="gap: 5px;">
                        <div class="f-r-c-c">
                          <div style="width: 60px">件</div>
                          <el-input-number size="mini" :min="1" :max="stock.quantity" v-model="stock.selectedQTY" />
                          <div class="light-oswald total"> / {{ stock.quantity }}</div>
                        </div>
                        <div class="f-r-c-c">
                          <div style="width: 60px">箱</div>
                          <el-input-number size="mini" :min="1" :max="stock.quantity" v-model="stock.cartons" />
                          <div class="light-oswald total"> / {{ stock.quantity }}</div>
                        </div>
                        <div class="f-r-c-c">
                          <div style="width: 60px">单箱</div>
                          <el-input-number size="mini" :min="1" :max="stock.quantity" v-model="stock.unitPerCarton" />
                          <div class="light-oswald total"> / {{ stock.quantity }}</div>
                        </div>
                      </div>
                      <div class="op trash" style="margin-right: 5px" title="delete stock"
                        @click="() => removePalletStock(stock, index)">
                        <svg-icon icon-class="trash" class="op-icon" />
                      </div>
                    </div>
                    <div class="stock-info-item f-r dimension">
                      <span>W: {{ stock.weight }}</span>
                      <span>V: {{ stock.volume }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="palletStock.length === 0" class="nothing-display">
                  <el-alert title="No stock in pallets group" type="warning" :closable="false" />
                </div>
              </div>
              <div class="f-r">
                <el-button size="small" type="primary" plain @click="confirmPalletsGroup"
                  :disabled="palletStock.length === 0">
                  Add Pallets
                </el-button>
                <el-button size="small" type="danger" plain @click="clearInputs">
                  Clear Inputs
                </el-button>
              </div>
            </div>
          </template>
        </basic-form>
      </div>
      <div class="pallet-right">
        <common-card title="All Pallets">
          <div class="group-list f-c">
            <div v-for="(group, index) in palletGroups" :key="index" class="f-r-c-sb group-row">
              <div class="left f-r">
                <div class="group-stock-item f-r light-oswald order-no" v-for="(item, index) in group.stock"
                  :key="index">
                  <span>{{ item.orderNo }}</span>
                  <span>SKU. {{ item.productNo }}</span>
                  <span class="bold-oswald">{{ item.quantity }}件</span>
                  <span class="bold-oswald">{{ item.cartons }}箱</span>
                  <span class="bold-oswald">单箱{{ item.unitPerCarton }}件</span>
                  <span class="bold-oswald">{{ item.riiCustomer }}</span>
                  <span class="bold-oswald">{{ item.platform }}</span>
                </div>
              </div>
              <div class="right f-c">
                <span>{{ group.palletCount }} P</span>
                <address-tag class="basic-address-tag" :address="group.address" />
                <el-button class="add-stock-but" size="mini" type="danger" plain
                  @click="() => removePalletsGroup(index)">Remove</el-button>
              </div>
            </div>
          </div>
        </common-card>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import CommonCard from '@/components/common/CommonCard.vue'
import BasicForm from '@/components/common/BasicForm.vue'
import { getOrderByCubeNo } from '@/api/orderProxy'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import { ScanPalletsForm } from '@/core/models/order'
import { FormModes } from '@/core/configs/types'
import { Message } from 'element-ui'
import AddressTag from '@/components/address/AddressTag.vue'

export default {
  name: 'OrderScanCreate',
  components: {
    CommonCard,
    BasicForm,
    AddressTag
  },
  props: {
    updatePOOptions: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      FormModes,
      orderNoInput: 'SUB27931569',
      orderInfo: null,
      loadingOrderInfo: false,
      debouncedOrderQuery: debounce(this.searchOrder, 500),
      palletForm: cloneDeep(ScanPalletsForm),
      palletStock: [],
      palletGroups: []
    }
  },
  watch: {
    orderNoInput: {
      handler: function (val) {
        if (val) {
          this.debouncedOrderQuery(val)
        } else {
          this.orderInfo = null
        }
      },
      immediate: true
    },
    palletGroups: {
      handler: function (val) {
        const options = val.map(one => {
          return one.stock.map(innerOne => innerOne.purchaseNo)
        }).flat()
        this.updatePOOptions([...new Set(options)])
      }
    }
  },
  methods: {
    addPalletStock(stock, index) {
      if (this.orderInfo == null) {
        Message({
          message: 'No order info',
          type: 'error',
          duration: 1000
        })
        return
      }
      const po = this.orderInfo.purchaseNo
      const stockNo = stock.productNo
      const _index = this.palletStock.findIndex(item => item.productNo === stockNo)
      if (_index > -1) {
        Message({
          message: 'Product already added',
          type: 'error',
          duration: 1000
        })
      } else {
        this.palletStock.push({
          ...stock,
          quantity: stock.leftQuantity,
          orderNo: this.orderInfo.cubeDeliveryNo,
          selectedQTY: stock.leftQuantity,
          cartons: 1,
          unitPerCarton: 1,
          purchaseNo: po
        })
        this.$set(this.orderInfo.stock[index], 'leftQuantity', 0)
      }
    },
    removePalletStock(stock) {
      const index = this.palletStock.findIndex(item => item.productNo === stock.productNo)
      const stockIndex = this.orderInfo.stock.findIndex(item => item.productNo === stock.productNo)
      if (index > -1 && stockIndex > -1) {
        this.$set(this.orderInfo.stock[stockIndex], 'leftQuantity', this.orderInfo.stock[stockIndex].quantityAvailable)
        this.palletStock.splice(index, 1)
        this.updateOrderInfoStock()
      }
    },
    confirmPalletsGroup() {
      if (this.palletStock.length === 0) {
        Message({
          message: 'No stock in pallets group',
          type: 'error',
          duration: 1000
        })
        return
      }
      let orders = this.palletStock.map(one => one.orderNo)
      orders = new Set(orders)
      if (orders.length > 1) {
        Message({
          message: 'More than one orders in the same pallets group!',
          type: 'error',
          duration: 1000
        })
        return
      }
      const [passed, formInputs] = this.$refs.palletForm.validateAllInputs()
      if (passed) {
        if (formInputs.palletCount <= 0) {
          this.$message.error('Pallet count must be large than 0!')
          return
        }
        const palletCount = formInputs.palletCount
        // cartons must be less thant selected QTY
        const flag = this.palletStock.filter(one => one.selectedQTY < one.cartons).length > 0
        if (flag) {
          this.$message.error('Cartons are larger than quantity')
          return
        }
        // multiple pallts with multiple skus
        // 1. quantity must be dividen by cartons
        // 2. cartons must be dividen by pallts
        if (palletCount > 1) {
          // check multiple pallets and multiple cartons
          let flag = this.palletStock.filter(one => one.selectedQTY % one.cartons !== 0).length > 0
          if (flag) {
            this.$message.error('In multiple pallets, quantity must be divided by cartons')
            return
          }
          flag = this.palletStock.filter(one => one.cartons % palletCount !== 0).length > 0
          if (flag) {
            this.$message.error('In multiple pallets, carton must be divided by palelt count')
            return
          }
        }
        if (palletCount === 1) {
          let flag = this.palletStock.filter(one => one.unitPerCarton * (one.cartons - 1) >= one.selectedQTY).length > 0
          if (flag) {
            this.$message.error('In single pallet, unit per carton is too large')
            return
          }
          flag = this.palletStock.filter(one => one.unitPerCarton * one.cartons < one.selectedQTY).length > 0
          if (flag) {
            this.$message.error('In single pallet, unit per carton is too small')
            return
          }
        }
        // single pallet with multiple skus
        // 1. last carton may have quantity that is different to other carton
        // if (palletCount > 1 && productsCount === 1) {
        //   // check quantity and pallet count can be divided
        //   const totalQuantity = this.palletStock.reduce((acc, cur) => acc + cur.selectedQTY, 0)
        //   if (totalQuantity % palletCount !== 0) {
        //     Message({
        //       message: `Total quantity ${totalQuantity} can not be dividen by pallet count ${formInputs.palletCount}`,
        //       type: 'error',
        //       duration: 2000
        //     })
        //     return
        //   }
        // }
        // add pallets group
        const basicInfo = cloneDeep(formInputs)
        const stocks = this.palletStock.map(one => {
          const { quantity, cartons, unitPerCarton, selectedQTY, ...rest } = one
          return {
            ...rest,
            palletCount,
            cartons,
            quantity: one.selectedQTY,
            unitPerCarton: palletCount === 1 ? unitPerCarton : (selectedQTY / cartons)
          }
        })
        basicInfo.stock = stocks
        this.palletGroups.push(basicInfo)
        this.clearInputs()
        // this.updateOrderInfoStock()
      } else {
        Message({
          message: 'Invalid inputs',
          type: 'error',
          duration: 1000
        })
      }
    },
    removePalletsGroup(index) {
      // remove pallets group
      this.palletGroups.splice(index, 1)
      this.updateOrderInfoStock()
    },
    updateOrderInfoStock() {
      if (this.orderInfo) {
        const stockQtyMap = {}
        this.palletGroups.forEach(group => {
          group.stock.forEach(one => {
            if (!(one.productNo in stockQtyMap)) {
              stockQtyMap[one.productNo] = 0
            }
            stockQtyMap[one.productNo] += one.quantity
          })
        })
        const currentUsed = Object.fromEntries(this.palletStock.map(one => [one.productNo, one.quantity]))
        const stockLefts = {}
        const stock = this.orderInfo?.stock ?? []
        stock.forEach(one => {
          stockLefts[one.productNo] = one.quantityAvailable - (stockQtyMap?.[one.productNo] ?? 0) - (currentUsed?.[one.productNo] ?? 0)
        })
        this.palletStock.forEach((one, index) => {
          if (one.productNo in stockLefts) {
            const total = this.palletStock[index].quantity + stockLefts[one.productNo]
            this.$set(this.palletStock[index], 'quantity', total)
            stockLefts[one.productNo] = 0
          }
        })
        this.orderInfo.stock.forEach((one, index) => {
          if (one.productNo in stockLefts) {
            this.$set(this.orderInfo.stock[index], 'leftQuantity', stockLefts[one.productNo])
          }
        })
      }
    },
    resetPalletStock() {
      //
    },
    clearInputs() {
      Object.values(this.palletForm).forEach(one => {
        one.value = one.default
      })
      // while (this.palletStock.length > 0) {
      //   this.removePalletStock(this.palletStock[0])
      // }
      this.palletStock.splice(0, this.palletStock.length)
      this.updateOrderInfoStock()
    },
    formValueChange(form, key, val) {
      this.$set(get(form, key), 'value', val)
    },
    searchOrder(cubeNo) {
      this.loadingOrderInfo = true
      getOrderByCubeNo(cubeNo).then(res => {
        res.stock.forEach(stock => {
          stock.leftQuantity = stock.quantityAvailable
          if (res.platform) {
            stock.platform = res.platform
          }
          stock.riiCustomer = res.riiCustomer
        })
        this.orderInfo = res
      }).catch(() => { }).finally(() => {
        this.loadingOrderInfo = false
      })
    },
    getScanOrderProductGroups() {
      return this.palletGroups.map(one => ({
        addressId: one.address.id,
        customerRefNo: one.customerRefNo,
        palletCount: one.palletCount,
        hold: one.hold,
        note: one.note,
        products: one.stock.map(one => ({
          serialNoMatch: one.serialNoMatch,
          productNo: one.productNo,
          productName: one.productName,
          customerOrderNo: one.orderNo,
          barcode: one.barcode,
          quantity: one.quantity,
          cartons: one.cartons,
          perPackageQty: one.unitPerCarton,
          riiCustomer: one.riiCustomer,
          platform: one.platform
        }))
      }))
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.container {
  width: 100%;
  // margin: 10px 20px;
  gap: 20px;
}

.pick-order {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .order-no-input {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    .el-input {
      width: 500px;
    }
  }

  .order-preview {
    .order-detail {
      min-height: 100px;

      .address-info {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      .product-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
      }
    }

    .nothing-display {
      min-height: 110px;
      color: gray;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.add-button {
  border-radius: 4px;
  border: none;
  text-align: center;

  .inner {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.order-product-item {
  display: flex;
  flex-direction: row;
  padding: 10px 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  gap: 20px;
  align-items: center;
  background-color: #eee;

  .left {
    display: flex;
    flex-direction: column;
    gap: 0px;
    line-height: 1.2;
    font-size: 12px;

    .sku {
      font-size: 15px;
    }

    .barcode {
      font-size: 12px;
    }
  }

  .right {
    font-size: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.pallet-container {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;

  .pallet-left {
    width: 600px;
    flex-shrink: 0;
  }

  .pallet-right {
    flex-grow: 1;
    display: flex;
    flex-shrink: 0;
    overflow: hidden;
    width: calc(100% - 600px);

    .common-card {
      margin-left: 0px;
      flex-grow: 1;
      overflow: hidden;
    }

    .group-list {
      gap: 10px;

      .group-row {
        display: flex;
        flex-direction: row;
        padding: 10px 16px;
        border: 1px solid #eee;
        border-radius: 5px;
        gap: 20px;
        align-items: center;
        background-color: #f4f2f2;
        overflow: hidden;

        .left {
          gap: 5px;
          flex-wrap: wrap;
          flex-grow: 1;

          .group-stock-item {
            background-color: #fff;
            border-radius: 5px;
            padding: 5px 10px;
            gap: 10px;
            flex-wrap: wrap;
          }

          .order-no {
            font-size: 13px;
            gap: 10px;
          }
        }

        .right {
          width: 80px;
          flex-shrink: 0;
          font-size: 28px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

.op {
  gap: 5px;

  &:hover {
    cursor: pointer;
  }

  @extend .f-r-vc;

  span {
    font-size: $title-level-regular;
  }

  .op-icon {
    font-size: $dialog-header-op-icon-size;
    user-select: none;
  }

  &.add {
    filter: $svg-warning-color;
  }

  &.trash {
    filter: $svg-danger-color;
  }
}

.pallets-stock-list {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  .list-title {
    font-size: 15px;
    font-weight: bold;
  }

  .nothing-display {
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .pallet-stock-item {
    gap: 10px;
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-top: 5px;

    .stock-info-item {
      display: flex;
      flex-direction: row;
      gap: 5px;

      &.first {
        font-size: 16px;
        font-weight: bold;
        gap: 12px
      }
    }

    .left {
      .barcode {
        color: rgb(54, 53, 53);
      }

      // .product-no {
      // }
      .product-name {
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .right {
      gap: 5px;

      .dimension {
        margin-top: -2px;
        color: rgb(54, 53, 53);
        font-size: 14px;
      }

      .total {
        font-size: 24px;
        width: 50px;
      }

      .trash {
        margin-left: 12px;
      }

      .el-input-number {
        margin-right: 10px;
      }
    }
  }
}

.add-stock-but {
  border-radius: 5px;
}

.basic-address-tag {
  overflow: hidden;
  font-size: 14px;
}

.address-info {
  display: flex;
  flex-direction: row;
  gap: 10px;

  .purchase-no {
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px
  }

  .address-item {
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
}
</style>
